export default __webpack_public_path__ + "static/bg-wires--mobile-df609cd296729f9db5d8959497eb506e.jpg";